import { Stack, Typography } from '@mui/material';
import { TagsInput } from 'Components/HookFormInputs/TagsInput';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export enum ORDER_BY {
  ASCENDING = 1,
  DESCENDING = 2,
}
interface IOrderBy {
  label: string;
  value: number;
}

interface IOrderSort {
  selectedOrderBy: number;
  setSelectedOrderBy: Function;
}

export const OrderSort = ({
  selectedOrderBy,
  setSelectedOrderBy,
}: IOrderSort) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;

  const orderBy: IOrderBy[] = [
    {
      label: dictionary.orderByAscendingAlphabet,
      value: ORDER_BY.ASCENDING,
    },
    {
      label: dictionary.orderByDescendingAlphabet,
      value: ORDER_BY.DESCENDING,
    },
  ];

  return (
    <Stack
      gap='20px'
      sx={{
        mb: isDesktop ? undefined : '16px',
      }}
      role='radiogroup'
    >
      <Typography
        variant='body1'
        sx={{ color: isDesktop ? 'primary.main' : undefined }}
      >
        {dictionary.sortBy}
      </Typography>
      <TagsInput
        filterTags={orderBy}
        isActive={(tag: IOrderBy) => {
          return tag.value === selectedOrderBy;
        }}
        resetTags={() => {
          setSelectedOrderBy(0);
        }}
        toggleFilter={(tag: IOrderBy) => {
          setSelectedOrderBy(tag.value);
        }}
      />
    </Stack>
  );
};
